export const GUIDES_PROGRESS_STORAGE_KEY = 'company_guides_progress';

// I progressi restano nel browser: se il salvataggio non è possibile,
// la guida funziona comunque e semplicemente non ricorda i passi letti.
function sanitizeProgress(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return {};
  }
  return Object.fromEntries(
    Object.entries(value).filter(
      ([, steps]) => Array.isArray(steps) && steps.every((step) => Number.isInteger(step))
    )
  );
}

export function readGuidesProgress() {
  try {
    const raw = localStorage.getItem(GUIDES_PROGRESS_STORAGE_KEY);
    return raw ? sanitizeProgress(JSON.parse(raw)) : {};
  } catch (error) {
    return {};
  }
}

// `current` permette alla pagina di non perdere i passi letti in questa visita
// quando il browser non salva.
export function markGuideStepRead(slug, stepIndex, current = readGuidesProgress()) {
  const steps = current[slug] ?? [];
  const next = steps.includes(stepIndex) ? current : { ...current, [slug]: [...steps, stepIndex] };
  try {
    localStorage.setItem(GUIDES_PROGRESS_STORAGE_KEY, JSON.stringify(next));
  } catch (error) {
    // Il browser non permette di salvare: i progressi valgono solo per questa visita.
  }
  return next;
}

export function getGuideStatus(guide, progress) {
  const total = guide.steps.length;
  const read = new Set((progress[guide.slug] ?? []).filter((step) => step >= 0 && step < total));
  const done = read.size;
  if (done === 0) {
    return { state: 'new', done, total };
  }
  return { state: done === total ? 'completed' : 'in_progress', done, total };
}

// Primo passo ancora da leggere (indice da 0), oppure null se la guida è completata.
export function getFirstUnreadStep(guide, progress) {
  const read = progress[guide.slug] ?? [];
  const index = guide.steps.findIndex((_, step) => !read.includes(step));
  return index === -1 ? null : index;
}

// Inviti alla prima visita del modulo: elenco delle guide già aperte o rimandate.
export const GUIDES_PROMPTS_STORAGE_KEY = 'company_guides_prompts_seen';

export function readStringList(key) {
  try {
    const value = JSON.parse(localStorage.getItem(key));
    return Array.isArray(value) ? value.filter((item) => typeof item === 'string') : [];
  } catch (error) {
    return [];
  }
}

export function addToStringList(key, item) {
  const list = readStringList(key);
  if (list.includes(item)) {
    return;
  }
  try {
    localStorage.setItem(key, JSON.stringify([...list, item]));
  } catch (error) {
    // Il browser non permette di salvare: l'informazione vale solo per questa visita.
  }
}

export function markGuidePromptSeen(slug) {
  addToStringList(GUIDES_PROMPTS_STORAGE_KEY, slug);
}

export function shouldShowGuidePrompt(guide, progress) {
  return !(progress[guide.slug] ?? []).length && !readStringList(GUIDES_PROMPTS_STORAGE_KEY).includes(guide.slug);
}

// Tour sulle pagine completati: rendono discreto il pulsante «Guida».
export const TOURS_DONE_STORAGE_KEY = 'company_tours_done';

export function markTourDone(id) {
  addToStringList(TOURS_DONE_STORAGE_KEY, id);
}

export function isTourDone(id) {
  return readStringList(TOURS_DONE_STORAGE_KEY).includes(id);
}
